module.exports = __webpack_public_path__ + "img/WP23-volunteers3.e734d027.jpg";